// BEGIN google profinder
async function addProductTags(newVariantList) {
    ontech.setCartModified();
    var cart = await ontech.getCart("profinder-addProductTags");
    var cartItems = cart.items;

    for (var i = 0; i < cartItems.length; i++) {
        for (var j = 0; j < newVariantList.length; j++) {
            if (cartItems[i].variant_id === (newVariantList[j].id * 1)) {
                var tags = "";

                // getProductInfo for new item
                let productInfo = await getProductInfo(cartItems[i].product_id);

                // retrieve the product tags
                if (productInfo && productInfo && productInfo.tags) {
                    tags = productInfo.tags;

                    if (tags) {
                        try {
                            await $.post('/cart/change.js', {
                                'line': i + 1,
                                'quantity': cartItems[i].quantity,
                                'properties': {
                                    [Cart.Properties.PRODUCT_TAGS]: tags
                                },
                            },
                                null,
                                'json'
                            );
                        } catch (err) {
                            ontech.log.error("Error adding product tags", err);
                        }
                    }
                }
                break;
            }
        }
    }
}

window.updateCartCollection = async function (id, quantity) {
    try {
        $(".cart_total_price").html("Updating Cart...");
        $("#book-install-btn").prop("disabled", true);

        let tmpCart = ontech.insertData;
        let foundInCart = false;
        // Cycles through the list to update the quantity if the item already exists
        for (let i = 0; i < tmpCart.length; i++) {
            if (tmpCart[i].id == id) {
                tmpCart[i].quantity = quantity;
                foundInCart = true;
                break;
            }
        }
        if (!foundInCart) {
            tmpCart.push({
                id: id,
                quantity: quantity
            })
        }

        ontech.insertData = tmpCart;
        clearTimeout(ontech.insertTimers);
        ontech.insertTimers = setTimeout(() => {
            addToCart()
        }, 1500);

    } catch (error) {
        ontech.log.error(error);
    }
}

ontech.insertTimers = [];
ontech.insertData = [];

function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

async function sleep(fn, ...args) {
    await timeout(3000);
    return fn(...args);
}

async function addToCart() {
    let cart = await ontech.getCart("profinder-addToCart");
    let newCart = []
    let squishedCart = [];
    let retVal = null;
    let analyticsCart = [];

    for (let i = cart.items.length - 1; i >= 0; i--) {
        let duplicateList = squishedCart.filter(item => (item.id === cart.items[i].id));
        if (duplicateList.length > 0) {
            let line = squishedCart.indexOf(duplicateList[0]);
            squishedCart[line].quantity += cart.items[i].quantity;
        } else {
            squishedCart.push(cart.items[i]);
        }
    }

    squishedCart.reverse();
    //loop through existing CART to recreate existing cart altering quantities where necessary

    for (let i = squishedCart.length - 1; i >= 0; i--) {
        let tmpQuantity = squishedCart[i].quantity;
        for (let x = 0; x < ontech.insertData.length; x++) {
            if (parseInt(ontech.insertData[x].id) === squishedCart[i].id) {

                let analytics_item = {
                    action: '',
                    productID: ontech.insertData[x].id,
                    productSKU: '',
                    productName: '',
                    productPrice: ''
                };

                if (squishedCart[i].quantity < ontech.insertData[x].quantity) {
                    analytics_item.action = 'inc'
                } else if (squishedCart[i].quantity > ontech.insertData[x].quantity && ontech.insertData[x].quantity > 0) {
                    analytics_item.action = 'dec'
                } else {
                    analytics_item.action = 'rem'
                }

                analyticsCart.push(analytics_item)
                tmpQuantity = ontech.insertData[x].quantity;
            }
        }

        newCart.push({
            id: squishedCart[i].id,
            quantity: tmpQuantity,
            properties: squishedCart[i].properties
        });
    }

    //loop through the new items to add to see if they haven't already been added, if not, add them
    for (let i = 0; i < ontech.insertData.length; i++) {
        let exists = false;
        for (let x = 0; x < newCart.length; x++) {
            if (newCart[x].id === parseInt(ontech.insertData[i].id)) {
                exists = true;
            }
        }
        if (!exists) {
            let analytics_item = {
                action: 'add',
                productID: ontech.insertData[i].id,
                productSKU: '',
                productName: '',
                productPrice: ''
            };
            analyticsCart.push(analytics_item);
            newCart.push({
                id: ontech.insertData[i].id,
                quantity: ontech.insertData[i].quantity
            });
        }
    }

    let clearResult = await $.post("/cart/clear.js", {}, null, "json");
    retVal = await $.post("/cart/add.js", { items: newCart }, null, "json");
    await addProductTags(ontech.insertData);
    ontech.insertData = [];

    ontech.setCartModified();

    let isMembershipInCart = ontech.state.get(State.Membership.IN_CART);
    if (isMembershipInCart) {
        await UpdateCartMembershipBenefits();
        let tmpCart = await $.get('/cart.json', null, null, 'json');
        ontech.log.debug(tmpCart);
    }

    await window.checkZipcodeAndCart();
    try {
        for (let i = 0; i < analyticsCart.length; i++) {
            for (let j = 0; j < retVal.items.length; j++) {
                if (parseInt(analyticsCart[i].productID) === retVal.items[j].variant_id) {
                    analyticsCart[i].productSKU = retVal.items[j].sku;
                    analyticsCart[i].productName = retVal.items[j].product_title;
                    analyticsCart[i].productPrice = retVal.items[j].price / 100.0;
                }
            }
        }
    } catch (error) {
        ontech.log.error(error);
    }

    for (let i = 0; i < analyticsCart.length; i++) {
        trackProduct(analyticsCart[i]);
    }
}

function compareProperties(obj, source) {
    return Object.keys(source).every(
        (key) => obj.hasOwnProperty(key) && obj[key] == source[key]
    );
}

window.getCartItemQuantity = async function (id) {
    let quantity = null;
    try {
        cart = await ontech.getCart("profinder-getCartItemQuantity");

        let reducedCart = [];
        // squashes cart
        for (let i = 0; i < cart.items.length; i++) {
            let { _split_group, ...newProperties } = cart.items[i].properties;
            cart.items[i].properties = newProperties;
            let result = reducedCart.findIndex(
                (x) =>
                    x.id === cart.items[i].id &&
                    compareProperties(x.properties, cart.items[i].properties)
            );
            if (result != -1) {
                reducedCart[result].quantity += cart.items[i].quantity;
            } else {
                result = reducedCart.push(cart.items[i]) - 1;
            }
        }
        // looks through the reduced cart for the id
        for (let i = 0; i < reducedCart.length; i++) {
            if (reducedCart[i].id == id) {
                quantity = reducedCart[i].quantity;
                break;
            }
        }
        return quantity;
    } catch (error) {
        ontech.log.error(error);
    }
};

window.getCartTotalAndHasService = async function () {
    try {
        let retVal = {
            price: 0,
            hasService: false,
        };

        let cart = await ontech.getCart(Cart.Profinder.CART_TOTAL_AND_HAS_SERVICE);

        retVal.price = cart.total_price;
        for (const cartItem of cart.items) {
            if (isCartItemService(cartItem)) {
                retVal.hasService = true;
                break;
            }
        }

        return retVal;
    } catch (error) {
        ontech.log.error(error);
    }
};

window.updateCartTotalSection = async function () {
    try {
        if ($(".cart_total_price")) {
            let retVal = await window.getCartTotalAndHasService();
            let price = retVal.price;
            price = parseFloat(price);
            price = (price / 100).toFixed(2);
            $(".cart_total_price").html("$" + price);
            return retVal.hasService;
        }
    } catch (error) {
        ontech.log.error(error);
    }
};

window.checkZipcodeIsValid = function (zipcode) {
    try {
        let regex = RegExp(/^\d{5}[-\s]?(?:\d{4})?$/);

        ontech.log.debug("*** setIsValid Start ***");

        return regex.test(zipcode);
    } catch (error) {
        ontech.log.error(error);
    }
};

window.checkZipcodeAvailability = async function (zipcode, variantId = window.theme.strings.gpVariantId) {
    try {
        let retVal = {
            isValid: false,
            installInfo: null,
        };

        if (checkZipcodeIsValid(zipcode)) {
            let response = await _makeGetCall(
                getShopifyUrl() +
                "/getVariantAvailabilityByZipcode?zipCode=" +
                zipcode
            );

            let zipcodeResponse = ProcessZipcodeResponse(response, variantId);

            if (zipcodeResponse) {
                retVal.isValid = true;
                SetZipcodeCookie(zipcode);
                let clientName = ontech.state.get(State.CLIENT_NAME);
                

                if (!checkClientName(clientName, ClientNames.D2C_SMARTINSURE)) {
                    retVal.installInfo = await GetEarliestInstallationDate(zipcode);
                } else {
                    ontech.log.info("smartinsure skipping earliest install date");
                }
            } else {
                ontech.log.warn(`zip not serviced`);
            }
        }
        return retVal;
    } catch (error) {
        window.showToast(
            "Error determining product availability.<br/>Please try again later.",
            "error"
        );
        let errMsg = `Error calling getVariantAvailabilityByZipcode for zip ${zipcode}`;
        ontech.log.error(errMsg, error); // Added to track a rollbar error logged in production.
    }
};

function ProcessZipcodeResponse(response, variantId) {
    try {
        var availableServiceZip = false;

        if (response.length === 0) {
            ontech.log.warn("*** length of response is 0 ***");
            availableServiceZip = true;
        } else if (response.error) {
            ontech.log.error("*** responded with an error ***");
        } else if (
            response[0].state === null &&
            response[0].variantId === "ALL"
        ) {
            ontech.log.info("*** response marked all for ignored ***");
            availableServiceZip = false;
        } else {
            let isAvailable = true;
            for (let i = 0; i < response.length; i++) {
                if (variantId) {
                    if (
                        response[i].variantId ==
                        variantId
                    ) {
                        ontech.log.debug(
                            `*** Setting variant ID ${response[i].variantId} to NOT available!`
                        );
                        isAvailable = false;
                    }
                } else {
                    ontech.log.warn(
                        "variantId missing or not set, defaulting to not available"
                    );
                }
            }
            if (isAvailable) {
                availableServiceZip = true;
            }
        }

        return availableServiceZip;
    } catch (error) {
        ontech.log.error(error);
    }
}

function SetZipcodeCookie(zipcode) {
    let now = new Date();
    let expirationDate = null;
    if (now.getMonth() === 11) {
        expirationDate = new Date(now.getFullYear() + 1, 0, 1);
    } else {
        expirationDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    }
    ontech.state.do(State.Actions.ZIPCODE_CHANGED, zipcode);
    // Cookies.set("zipcode", zipcode, {
    //     domain: "ontechsmartservices.com",
    //     path: "/",
    //     secure: true,
    //     expires: expirationDate,
    // });
}

async function GetEarliestInstallationDate(zipcode) {
    try {
        let response = await $.get(
            getShopifyUrl() +
            "/getInstallationDate?zipCode=" +
            zipcode +
            "&variantId=" +
            window.theme.strings.gpVariantId + "&clientName=" + ontech.state.get(State.CLIENT_NAME),
            null,
            null,
            "json"
        );

        if (response.schedule) {
            var dateSplit = response.schedule.date.split("-");
            let installDateInfo = {
                installDate: response.schedule.date,
                installDateFormat: new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "2-digit",
                }).format(
                    new Date(dateSplit[0], dateSplit[1] - 1, dateSplit[2])
                ),
                installDay: response.schedule.day,
                installDayNumber: response.schedule.number,
                available: response.schedule.available,
                times: response.schedule.times,
            };
            return installDateInfo;
        } else if (response.error) {
            ontech.log.error(
                "Get Earliest Installation Date Failed with the following error: " +
                response.error
            );
        }
    } catch (error) {
        ontech.log.error(error);
    }
}

// Profinder Logic to disable/enable the book install button
// *** checkZipcodeAndCart ***
window.checkZipcodeAndCart = async function () {
    try {
        var zipCode = ontech.state.get(State.ZIP_CODE);
        var hasService = await window.updateCartTotalSection();
        // check google profinder variant availability for zip code in zipcode cookie
        var isGpZipAvailable = await window.checkZipcodeCookieAvailability();
        // if there is no zip code, but cart has an install, enable book install button ignoring availability
        // if google profinder variant is available in zipcode and cart has an install, enable book install button based on availability
        if ((!zipCode && hasService) || (isGpZipAvailable && hasService)) {
            $("#book-install-btn").addClass("g-ontech-book-install-active-btn");
            $("#book-install-btn").prop("disabled", false);
        } else {
            $("#book-install-btn").removeClass("g-ontech-book-install-active-btn");
            $("#book-install-btn").prop("disabled", true);
        }
        // check for sha variant availability in zip code
        // and enable/disable sha button based on availability
        if (zipCode) {
            var googleShaVariantId = ontech.state.get(State.Settings.GOOGLE_SHA_VARIANT_ID);
            var isShaZipAvailable = await window.checkZipcodeAvailability(zipCode, googleShaVariantId);
            if (isShaZipAvailable.isValid) {
                ontech.disableShaAddToCartButton(false);
            } else {
                $(".sha-add-button").show();
                $(".sha-remove-button").hide();
                ontech.disableShaAddToCartButton(true);
            }
        }
    } catch (error) {
        ontech.log.error(error); // Added to track a rollbar error logged in production.
        $("#book-install-btn").addClass("g-ontech-book-install-active-btn");
        $("#book-install-btn").prop("disabled", false);
        ontech.log.error(error);
    }
};

function setInstallInfo(response) {
    let elem = $("#install-info");
    let retVal = false;

    if (response.isValid) {
        if (response.installInfo) {
            elem.html(
                'Book an install in <a data-toggle="modal" data-target="#zipUpdateModal" href="" class="analytics" data-category="modal" data-state="open">' +
                ontech.state.get(State.ZIP_CODE) +
                "</a> as soon as " +
                response.installInfo.installDateFormat.substr(
                    0,
                    response.installInfo.installDateFormat.length - 6
                )
            );
            ontech.disableShaAddToCartButton(false);
            retVal = true;
        } else {
            elem.html(
                'Book an install in <a data-toggle="modal" data-target="#zipUpdateModal" href="" class="analytics" data-category="modal" data-state="open">' +
                ontech.state.get(State.ZIP_CODE) +
                "</a>"
            );
            ontech.disableShaAddToCartButton(true);
            retVal = true;
        }
    } else {
        elem.html(
            "Hmm, we don't recognize <a data-toggle='modal' data-target='#zipUpdateModal' href='#' class='analytics' data-category='modal' data-state='open'>" +
            ontech.state.get(State.ZIP_CODE) +
            "</a>. Please edit zip or call for assistance. "
        );
        ontech.disableShaAddToCartButton(true);
    }
    return retVal;
}

// variantId defaults to the main google profinder variant
window.checkZipcodeCookieAvailability = async function (variantId = window.theme.strings.gpVariantId) {
    try {
        let retVal = false;
        let zipCode = ontech.state.get(State.ZIP_CODE);
        if (zipCode) {
            $("#zipCodeNoService").html(zipCode);
            let response = await window.checkZipcodeAvailability(zipCode, variantId);
            retVal = this.setInstallInfo(response);
        } else {
            $("#install-info").html(
                'Please enter your <a data-toggle="modal" data-target="#zipUpdateModal" href="" class="analytics" data-category="modal" data-state="open">zip code</a> to book an install'
            );
        }
        return retVal;
    } catch (error) {
        ontech.log.error(error);
        return false;
    }
};

window.testZipcodeAvailability = async function () {
    window.checkZipcodeCookieAvailability();
};

// Begin Shogun Google Custom Cart Quantity Control
var iconRootUrl = "https://cdn.shopify.com/s/files/1/0054/2126/9095/files/";

ontech.swapIcon = function (event, variantId, state, operator) {
    'use strict';
    var quantityFieldId = "g_quantity_" + variantId;
    var quantityField = document.getElementById(quantityFieldId);

    if (
        (!isNaN(quantityField.value) &&
            quantityField.value > 0 &&
            operator === "minus") ||
        (!isNaN(quantityField.value) && operator === "plus")
    ) {
        event.target.src =
            iconRootUrl + "icon_" + operator + "_" + state + ".svg";
    }
};

async function updateProfinderHeader(variantId, quantityValue) {
    await window["updateCartCollection"](variantId, quantityValue);
    //await window["checkZipcodeAndCart"]();
}

// Profinder Logic
ontech.setCartQuantity = function (variantId, operator) {
    'use strict';
    var quantityFieldId = "g_quantity_" + variantId;
    var quantityField = document.getElementById(quantityFieldId);
    var quantityValue = quantityField.value;
    var iconMinus = document.getElementById("g_minus_" + variantId);

    if (!isNaN(quantityValue)) {
        if (operator === "plus") {
            quantityValue++;
        }

        if (operator === "minus" && quantityValue > 0) {
            quantityValue--;
        }
    } else {
        quantityValue = 0;
    }

    quantityField.value = quantityValue;

    if (quantityField.value < 1) {
        iconMinus.src = iconRootUrl + "icon_minus_disabled.svg";
    } else {
        iconMinus.src = iconRootUrl + "icon_minus_inactive.svg";
    }

    updateProfinderHeader(variantId, quantityValue);
};

ontech.detectKeyboardChange = function (event, variantId) {
    'use strict';
    if (event.keyCode === Keycodes.ENTER) {
        event.preventDefault();
        ontech.setCartQuantity(variantId);
    }
};

ontech.setInitialQuantity = function (variantId) {
    'use strict';
    var quantityFieldId = "g_quantity_" + variantId;
    var quantityField = document.getElementById(quantityFieldId);
    var iconMinus;

    window["getCartItemQuantity"](variantId).then(function (quantity) {
        if (!isNaN(quantity) && quantity < 1) {
            iconMinus = document.getElementById("g_minus_" + variantId);
            iconMinus.src = iconRootUrl + "icon_minus_disabled.svg";
            quantityField.value = 0;
        } else {
            quantityField.value = quantity;
        }
    });
};
// End Shogun Google Custom Cart Quantity Control

ontech.isShaInCart = function (cartLineItems) {
    let retVal = false;
    var googleShaVariantId = ontech.state.get(State.Settings.GOOGLE_SHA_VARIANT_ID);
    var ontechShaVariantId = ontech.state.get(State.Settings.ONTECH_SHA_VARIANT_ID);
    var ringShaVariantId = ontech.state.get(State.Settings.RING_SHA_VARIANT_ID);
    if (cartLineItems && cartLineItems.length > 0) {
        for (let i = 0; i < cartLineItems.length; i++) {
            if (cartLineItems[i].variant_id && (cartLineItems[i].variant_id == googleShaVariantId || cartLineItems[i].variant_id == ontechShaVariantId || cartLineItems[i].variant_id == ringShaVariantId)) {
                retVal = true;
                break;
            }
        }
    }
    return retVal;
}

ontech.toggleShaAddToCartButton = async function () {
    const cart = await ontech.getCart("profinder-toggleShaAddToCartButton");
    if (ontech.isShaInCart(cart.items)) {
        $(".sha-add-button").hide();
        $(".sha-remove-button").show();  
        ontech.setCookie(CookiesConstants.SHA_IN_CART, 'true');
    } else {
        $(".sha-add-button").show();
        $(".sha-remove-button").hide();
        ontech.removeCookie(CookiesConstants.SHA_IN_CART);
    }
};

ontech.disableShaAddToCartButton = function (autoDisable = false) {
    if (autoDisable) {
        $(".sha-add-button").prop("disabled", true);
        $("input.sha-add-button").attr("disabled", true);
        $("input.sha-add-button").addClass("disabled");
        $("button.sha-add-button").attr("disabled", true);
        $("button.sha-add-button").addClass("disabled");
        $(".sha-disable-text").show();
        customLog(
            "*** disableShaAddToCartButton true ***",
            "error"
        );
        ontech.removeShaItem(true);
    } else {
        $(".sha-add-button").prop("disabled", false);
        $("input.sha-add-button").attr("disabled", false);
        $("input.sha-add-button").removeClass("disabled");
        $("button.sha-add-button").attr("disabled", false);
        $("button.sha-add-button").removeClass("disabled");
        $(".sha-disable-text").hide();
        customLog(
            "*** disableShaAddToCartButton false ***",
            "error"
        );
    }
}

ontech.removeShaItem = async function (autoDisable = false) {
    var cart = await ontech.getCart("profinder-removeShaItem");
    var googleShaVariantId = ontech.state.get(State.Settings.GOOGLE_SHA_VARIANT_ID);
    var data, shaItem;
    for (var i = 0; i < cart.items.length; i++) {
        // TODO: Handle 2 possible SHA variant id's: window.googleShaVariantId and settings.ontechShaVariantId
        if (cart.items[i].variant_id === googleShaVariantId) {
            shaItem = cart.items[i];
            data = `quantity=0&line=${i + 1}`;
            break;
        }
    }

    if (data) {
        $(".sha-add-button").show();
        $(".sha-remove-button").hide();        
        ontech.setCartModified();
        var updatedCart;
        try {
            var params = {
                type: "POST",
                url: "/cart/change.js",
                data: data,
                dataType: "json",
            };
            await $.ajax(params);
            window.checkZipcodeAndCart();
            ontech.removeCookie(CookiesConstants.SHA_IN_CART);

            if (autoDisable) {
                ontech.showShaRemovedMessage('Google Nest Smart Home Advisor is not available in your area and has been removed from your cart.');
            }

            sendAnalytics("cart_remove", {
                [DataModel.PRODUCT_QUANTITY]: [shaItem.quantity],
                [DataModel.SITE_SECTION]: "product",
                [DataModel.PRODUCT_ID]: [shaItem.id],
                [DataModel.PRODUCT_NAME]: [shaItem.title],
                [DataModel.PRODUCT_BRAND]: [shaItem.vendor],//[cart.brand],
                [DataModel.PRODUCT_SKU]: [shaItem.sku],
                [DataModel.VARIANT_ID]: [shaItem.variant_id],
                [DataModel.PAGE_TYPE]: "remove_to_cart"
            })
        } catch (err) {
            ontech.log.error("removeShaItem: Error calling change.js", err);
        }
        return;
    }
};

// TODO: Handle 2 possible SHA variant id's: window.googleShaVariantId and window.ontechShaVariantId
var googleShaVariantId = ontech.state.get(State.Settings.GOOGLE_SHA_VARIANT_ID);
ontech.addShaToCart = async function (variantId = googleShaVariantId) {
    if (variantId) {
        var zipcode = ontech.state.get(State.ZIP_CODE);
        if (!zipcode) {
            $("#zipShaModal").modal("show");
            ontech.disableShaAddToCartButton(false);
        } else {
            var isZipAvailable = await window.checkZipcodeAvailability(zipcode, googleShaVariantId);
            if (isZipAvailable.isValid) {
                var cart = [
                    {
                        id: parseInt(variantId, 10),
                        quantity: [
                            [
                                {
                                    id: parseInt(
                                        variantId,
                                        10
                                    ),
                                    quantity: 1,
                                },
                            ],
                        ],
                    },
                ];
                $(".sha-add-button").hide();
                $(".sha-remove-button").show();      
                ontech.disableShaAddToCartButton(false);
                await window["AddToCartApi"](cart);

                ontech.setCookie(CookiesConstants.SHA_IN_CART, 'true');
            } else {
                ontech.disableShaAddToCartButton(true);
            }
        }
        window.checkZipcodeAndCart();
    } else {
        ontech.log.error("Error: SHA variant missing set.");
    }
};

window.ontech.removeShaFromCart = async function () {
    $(".sha-remove-button").hide();
    $(".sha-add-button").show();
    ontech.disableShaAddToCartButton(false);
    ontech.removeShaItem(); 
    window.checkZipcodeAndCart();    
}

$(".analytics").on("click", function () {
    let analytics_item = {
        category: $(this).attr("data-category"),
        categoryState: $(this).attr("data-state"),
        categoryID: $(this).attr("id"),
        categoryText: $(this).attr("data-text")
    };
    trackActions(analytics_item);
    return analytics_item;
});
